<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">
  <div *ngIf="successMessage"
    class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">
    <span class="material-symbols-outlined text-[20px]">check_circle</span>
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage"
    class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">
    <span class="material-symbols-outlined text-[20px]">error</span>
    {{ errorMessage }}
  </div>

  <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">
    <div>
      <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">Tourism Map Management</h2>
      <p class="text-sm text-slate-500 mt-1">Create and update tourism map destinations exposed to the public website.</p>
    </div>

    <button (click)="addNew()"
      class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">
      <span class="material-symbols-outlined text-[20px]">add</span>
      <span>Add</span>
    </button>
  </div>

  <div class="flex border-b border-slate-200 mb-4 gap-6">
    <button *ngFor="let lang of languages" (click)="setTab(lang.code)"
      class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
      [class.text-primary]="activeTab === lang.code" [class.border-primary]="activeTab === lang.code">
      <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200">
      {{ lang.name }} ({{ getLanguageCount(lang.code) }})
    </button>
  </div>

  <div class="mb-4 max-w-[420px]">
    <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterItems(activeTab)"
      placeholder="Search tourism map destinations"
      class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
  </div>

  <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
    <div class="overflow-x-auto">
      <table class="w-full text-left border-collapse">
        <thead>
          <tr class="bg-slate-50 border-b border-slate-200">
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Destination</th>
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Province</th>
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Category</th>
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Marker</th>
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Language</th>
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Status</th>
            <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right">Actions</th>
          </tr>
        </thead>

        <tbody class="divide-y divide-slate-100">
          <tr *ngFor="let obj of pagedItems" class="hover:bg-slate-50 transition-colors">
            <td class="px-3.5 py-2.5 text-slate-600">{{ obj.name }}</td>
            <td class="px-3.5 py-2.5 text-slate-600">{{ obj.province }}</td>
            <td class="px-3.5 py-2.5 text-slate-600">{{ obj.category }}</td>
            <td class="px-3.5 py-2.5 text-slate-600">{{ obj.markerLeft }}, {{ obj.markerTop }}</td>
            <td class="px-3.5 py-2.5 text-slate-600">
              <span class="px-2 py-1 rounded bg-slate-100 text-slate-600 text-xs">{{ obj.languageCode }}</span>
            </td>
            <td class="px-3.5 py-2.5 text-slate-600">
              <span class="px-2 py-1 rounded text-xs"
                [ngClass]="obj.isPublished ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-slate-600'">
                {{ obj.isPublished ? 'Published' : 'Draft' }}
              </span>
            </td>
            <td class="px-3.5 py-2.5 text-right">
              <div class="flex justify-end gap-2">
                <button class="p-1.5 text-slate-400 hover:text-primary" (click)="viewData(obj.tourismMapItemId, 'Edit')">
                  <span class="material-symbols-outlined text-[20px]">edit</span>
                </button>
                <button class="p-1.5 text-slate-400 hover:text-red-500" (click)="viewData(obj.tourismMapItemId, 'Delete')">
                  <span class="material-symbols-outlined text-[20px]">delete</span>
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="pagedItems.length === 0">
            <td colspan="7" class="px-3.5 py-8 text-center text-slate-400">No tourism map destinations found.</td>
          </tr>
        </tbody>

        <tfoot *ngIf="totalPages() > 1">
          <tr>
            <td colspan="7">
              <div class="flex justify-center mt-6 mb-6 gap-2">
                <button *ngFor="let page of [].constructor(totalPages()); let i = index"
                  (click)="changePage(i + 1)"
                  [ngClass]="currentPage === (i + 1) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'"
                  class="px-4 py-2 min-w-[40px] rounded hover:bg-blue-400 hover:text-white transition-colors text-sm">
                  {{ i + 1 }}
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</main>

<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4 py-6">
  <div class="bg-white w-full max-w-[840px] max-h-[calc(100vh-64px)] overflow-hidden rounded-xl shadow-xl flex flex-col">
    <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">
      <div>
        <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
          <span class="material-symbols-outlined text-[20px]">map</span>
          Tourism Map Destination
        </h3>
        <p class="text-sm text-slate-500 mt-0.5">Set map category, marker position, image, and localized details.</p>
      </div>
      <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
        <span class="material-symbols-outlined text-[22px]">close</span>
      </button>
    </div>

    <div class="p-5 space-y-6 bg-white shadow-sm overflow-y-auto flex-1 min-h-0">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <label class="form-field">
          <span>Category</span>
          <select [(ngModel)]="category" name="category">
            <option *ngFor="let cat of categories" [ngValue]="cat.value">{{ cat.label }}</option>
          </select>
        </label>

        <label class="form-field">
          <span>Sort Order</span>
          <input type="number" [(ngModel)]="sortOrder" name="sortOrder" min="0" />
        </label>

        <label class="form-field">
          <span>Marker Left (%)</span>
          <input type="number" [(ngModel)]="markerLeft" name="markerLeft" min="0" max="100" step="0.1" />
        </label>

        <label class="form-field">
          <span>Marker Top (%)</span>
          <input type="number" [(ngModel)]="markerTop" name="markerTop" min="0" max="100" step="0.1" />
        </label>
      </div>

      <div class="flex flex-col md:flex-row gap-4 md:items-center">
        <label class="form-field flex-1">
          <span>Image</span>
          <input type="file" (change)="onFileSelected($event)" name="image" accept="image/*" />
        </label>

        <label class="inline-flex items-center gap-2 text-sm font-semibold text-gray-700">
          <input type="checkbox" [(ngModel)]="isPublished" name="isPublished"
            class="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" />
          Published
        </label>
      </div>

      <div *ngIf="imagePreview" class="rounded-lg border border-slate-200 overflow-hidden bg-slate-50 w-full max-w-[320px]">
        <img [src]="imagePreview" alt="tourism map destination" class="w-full h-auto object-cover" />
      </div>

      <div class="flex border-b border-gray-200 gap-6 mt-3">
        <button *ngFor="let lang of languages" (click)="setTabPopup(lang.languageId)"
          class="pb-3 px-6 text-sm font-semibold border-b-2 flex items-center gap-2 transition-all"
          [class.text-primary]="activeTabPopup === lang.languageId"
          [class.border-primary]="activeTabPopup === lang.languageId">
          <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-gray-200" />
          {{ lang.name }}
        </button>
      </div>

      <form class="space-y-4">
        <div *ngIf="activeTabPopup === 1" class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="form-field"><span>Name (Khmer)</span><input [(ngModel)]="nameKh" name="nameKh" /></label>
          <label class="form-field"><span>Province (Khmer)</span><input [(ngModel)]="provinceKh" name="provinceKh" /></label>
          <label class="form-field"><span>Region (Khmer)</span><input [(ngModel)]="regionKh" name="regionKh" /></label>
          <label class="form-field"><span>Best Season (Khmer)</span><input [(ngModel)]="bestSeasonKh" name="bestSeasonKh" /></label>
          <label class="form-field"><span>Travel Time (Khmer)</span><input [(ngModel)]="travelTimeKh" name="travelTimeKh" /></label>
          <label class="form-field"><span>Visitor Focus (Khmer)</span><input [(ngModel)]="visitorFocusKh" name="visitorFocusKh" /></label>
          <label class="form-field md:col-span-2"><span>Highlights (comma separated)</span><input [(ngModel)]="highlightsKh" name="highlightsKh" /></label>
          <label class="form-field md:col-span-2"><span>Description (Khmer)</span><textarea [(ngModel)]="descriptionKh" name="descriptionKh" rows="3"></textarea></label>
        </div>

        <div *ngIf="activeTabPopup === 2" class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="form-field"><span>Name (English)</span><input [(ngModel)]="nameEn" name="nameEn" /></label>
          <label class="form-field"><span>Province (English)</span><input [(ngModel)]="provinceEn" name="provinceEn" /></label>
          <label class="form-field"><span>Region (English)</span><input [(ngModel)]="regionEn" name="regionEn" /></label>
          <label class="form-field"><span>Best Season (English)</span><input [(ngModel)]="bestSeasonEn" name="bestSeasonEn" /></label>
          <label class="form-field"><span>Travel Time (English)</span><input [(ngModel)]="travelTimeEn" name="travelTimeEn" /></label>
          <label class="form-field"><span>Visitor Focus (English)</span><input [(ngModel)]="visitorFocusEn" name="visitorFocusEn" /></label>
          <label class="form-field md:col-span-2"><span>Highlights (comma separated)</span><input [(ngModel)]="highlightsEn" name="highlightsEn" /></label>
          <label class="form-field md:col-span-2"><span>Description (English)</span><textarea [(ngModel)]="descriptionEn" name="descriptionEn" rows="3"></textarea></label>
        </div>
      </form>
    </div>

    <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">
      <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
        <span class="material-symbols-outlined text-[18px]">check_circle</span>
        Create
      </button>
      <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
        <span class="material-symbols-outlined text-[18px]">warning</span>
        Update
      </button>
      <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
        <span class="material-symbols-outlined text-[18px]">delete</span>
        Delete
      </button>
    </div>
  </div>
</div>
